
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'payments-ui-app',
  currentProjectVersion: 'static-1.28616',
  depVersions: {
  "payments-ui-app": "static-1.28616",
  "bend-plugin-arboretum": "static-1.1971",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.507",
  "crm_data": "static-4.93103",
  "data-fetching-client": "static-1.10074",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8676",
  "foundations-components-legacy": "static-1.1701",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6017",
  "hs-test-utils": "static-1.8466",
  "hub-http": "static-1.6637",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11920",
  "I18n": "static-7.1698",
  "jasmine-runner": "static-1.6879",
  "quartz": "static-1.7601",
  "raven": "static-3.5925",
  "react-dlb": "static-1.92",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.119",
  "react-utils": "static-2.5633",
  "reselect": "static-3.15",
  "stripe-js": "static-1.118",
  "ui-components-test-utils": "static-1.6057",
  "UIComponents": "static-3.8866",
  "usage-tracker-public": "static-1.7553",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38013",
  "payments-checkout-lib": "static-1.539",
  "cssUtils": "static-1.1050",
  "customer-data-objects": "static-1.8121",
  "FireAlarmUi": "static-1.4814",
  "foundations-assets": "static-1.5313",
  "foundations-theming": "static-1.4911",
  "graphql": "static-1.92",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12227",
  "icons": "static-2.699",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3314",
  "property-translator": "static-1.5807",
  "quartz-config": "static-1.1379",
  "quartz-core": "static-1.6820",
  "quartz-i18n": "static-1.1276",
  "quartz-routing": "static-1.1031",
  "quartz-tracking": "static-1.980",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17162",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "redux-thunk": "static-2.83",
  "redux-toolkit": "static-1.81",
  "ReduxMessenger": "static-2.10799",
  "rpc-client-utils": "static-1.5098",
  "sanitize-text": "static-1.8584",
  "SharedI18nStrings": "static-1.186",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.514",
  "superstore": "static-1.5186",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11574",
  "ui-images": "static-2.1269",
  "usage-tracker-core": "static-1.7592",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3878",
  "quartz-webpack": "static-1.3825",
  "bend-plugin-quartz-routing": "static-1.679",
  "bender-build-tools": "static-1.3518",
  "crm_universal": "static-1.22656",
  "customer-data-email": "static-1.18589",
  "customer-data-ui-utilities": "static-1.10261",
  "dispatcher": "static-1.146",
  "frontend-preferences-client": "static-1.8346",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8191",
  "quick-fetch": "static-1.4201",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4945",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2627",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9852",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.95",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2974",
  "ui-fonts": "static-1.1182",
  "HeadJS": "static-2.816",
  "hs-test-utils-bend-plugin": "static-1.3577",
  "msw": "static-1.102",
  "msw-config": "static-1.24",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.371",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4736",
  "foundations-components-test-utils": "static-1.6159",
  "ui-addon-draggable": "static-3.5175",
  "commerce-billing-lib": "static-1.20454",
  "commerce-shared-components-lib": "static-1.19489",
  "commerce-tools-ui-lib": "static-1.11246",
  "crm-message-bus": "static-1.44008",
  "customer-data-objects-ui-components": "static-1.13458",
  "customer-data-properties": "static-1.52920",
  "growth-payments-core": "static-1.26419",
  "ui-addon-iframeable": "static-1.9504",
  "usage-tracker": "static-1.7742",
  "usage-tracker-container": "static-1.7732",
  "sassPrefix": "static-1.317",
  "inbound-db-properties-service-client": "static-1.4118",
  "foundations-theming-base": "static-1.3896",
  "bend-plugin-foundations-theming": "static-1.3394",
  "stylex": "static-1.45",
  "opentelemetry-fe-types": "static-1.215",
  "hub-http-janus": "static-1.901",
  "hubspotter-http": "static-1.4941",
  "mobile-manifest-mixins": "static-1.599",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.590",
  "quartz-auth": "static-1.1276",
  "quartz-head": "static-1.1266",
  "quartz-test": "static-1.1276",
  "trellis-components": "static-1.2993",
  "usage-tracker-session-replay": "static-1.5428",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "immer": "static-1.104",
  "bend-plugin-chirp-manifest": "static-1.508",
  "chirp-fetch": "static-1.2329",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4901",
  "FormUrlGenerator": "static-2.5142",
  "sequences-lib": "static-1.8701",
  "apollo-link-hub-http": "static-2.5022",
  "FileManagerCore": "static-1.40259",
  "FileManagerLib": "static-1.40400",
  "hubspot-apollo-client": "static-1.5306",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.685",
  "timezone-utils": "static-2.5659",
  "ui-gdpr-components": "static-1.10651",
  "react-dnd-compat": "static-1.5038",
  "stylex-utils": "static-1.165",
  "trellis-theming": "static-1.1414",
  "react-flip-move": "static-1.82",
  "avatar-components": "static-1.2912",
  "hs-resources": "static-1.625",
  "pulse": "static-1.1069",
  "utility-belt": "static-1.2963",
  "zustand": "static-1.88",
  "batch-promise": "static-1.1974",
  "customer-data-associations": "static-1.7760",
  "customer-data-property-utils": "static-1.8473",
  "customer-data-tracking": "static-1.7300",
  "framework-data-schema-resolvers": "static-1.7320",
  "framework-data-table": "static-2.12767",
  "object-builder-ui-client": "static-1.49950",
  "payments-enrollment-embed-lib": "static-1.24118",
  "stripe-embedded-components": "static-1.8173",
  "ui-addon-opt": "static-4.8812",
  "ai-components-ui-library": "static-1.9943",
  "customer-data-rte": "static-1.33825",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24760",
  "growth-onboarding-confetti": "static-1.3491",
  "growth-onboarding-empty-states": "static-1.6462",
  "hubspot-prosemirror": "static-1.19205",
  "InboxConnectUtils": "static-4.15768",
  "payment-link-components": "static-1.24365",
  "payments-post-enroll-local-storage-lib": "static-1.5531",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.79",
  "quotes-client-types": "static-1.39101",
  "react-colorpicker": "static-2.10640",
  "ui-addon-upgrades": "static-9.18519",
  "ui-addon-video-player": "static-1.9057",
  "user-context": "static-1.5480",
  "restore-request-side-panel-lib": "static-1.1940",
  "atom": "static-1.5505",
  "reference-resolvers": "static-1.8606",
  "calling-global-api": "static-1.66050",
  "calling-internal-common": "static-1.31752",
  "calling-lifecycle-internal": "static-1.67432",
  "calling-lifecycle-messages": "static-1.59725",
  "commerce-products-lib": "static-1.10786",
  "conditional-properties-service-client": "static-1.4091",
  "crm-index-visualization-core": "static-1.4694",
  "crm-links": "static-1.6733",
  "crm-pipelines-api-client-types": "static-1.4422",
  "customer-data-properties-shared-msw-handlers": "static-1.10152",
  "external-options-client-types": "static-1.4420",
  "formula-editor": "static-1.14948",
  "google-libphonenumber": "static-1.48",
  "inbound-db-meta-service-client": "static-1.3749",
  "inbounddb-objects-service-types": "static-1.4501",
  "meetings-icalendar-utils-lib": "static-1.1065",
  "multi-currency-client-types": "static-1.3987",
  "pipeline-validation-client-types": "static-1.4259",
  "property-value-citations": "static-1.3534",
  "reference-resolvers-lite": "static-1.8534",
  "smart-data-capture-core": "static-1.382",
  "smart-property-lib": "static-1.8546",
  "tiered-pricing": "static-1.2160",
  "topics-actions-lib": "static-1.603",
  "trial-components-library": "static-1.14305",
  "ui-addon-form-validation": "static-1.11341",
  "laboratory-lib": "static-3.7578",
  "onboarding-scopes": "static-1.6880",
  "seat-types-lib": "static-1.964",
  "magpie-lib": "static-1.5864",
  "navigation-messaging": "static-1.8409",
  "ts-schema": "static-1.4371",
  "opentelemetry-web": "static-1.20",
  "beacon-keepalive-queue": "static-1.128",
  "hub-http-shared-msw-handlers": "static-1.10825",
  "hubspotter-http-shared-msw-handlers": "static-1.10823",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8558",
  "breeze-artifacts-sdk": "static-1.723",
  "copilot-toolkit": "static-1.12067",
  "audio-components": "static-1.6505",
  "ContentUtils": "static-1.69371",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29992",
  "FileManagerImages": "static-1.37911",
  "html-to-image": "static-1.64",
  "immerable": "static-1.4569",
  "ui-universal-auth": "static-1.9641",
  "urlinator": "static-1.4944",
  "video-components": "static-1.14355",
  "video-data-lib": "static-1.36011",
  "video-embed": "static-1.36845",
  "hubspot-apollo-cache": "static-1.765",
  "event-emitter": "static-1.1388",
  "framework-builder-read-service-client": "static-1.4301",
  "fdsr-migration-layer": "static-1.439",
  "bend-plugin-pulse": "static-1.572",
  "fast-json-patch": "static-1.73",
  "framework-data-schema-quick-fetch": "static-1.7225",
  "persist-promise": "static-1.4131",
  "customer-data-reference-ui-components": "static-1.13595",
  "tasks-actions-lib": "static-1.352",
  "reporting-data": "static-1.69216",
  "purchase-motions-components": "static-1.6575",
  "growth-onboarding-feedback-components": "static-1.7010",
  "growth-onboarding-reliability": "static-1.5510",
  "marketplace-ui-apps-core": "static-1.19506",
  "onboarding-tours": "static-1.17322",
  "stripe-connect-js": "static-1.81",
  "chatspot-core": "static-1.23571",
  "content-assistance-lib": "static-1.8356",
  "draft-content-plugins": "static-1.29084",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22288",
  "rich-text-lib": "static-1.20486",
  "breeze-engine-lib": "static-1.2029",
  "poll-commands": "static-1.3902",
  "video-components-external": "static-1.12353",
  "trellis-story-utils": "static-1.4930",
  "ui-addon-react-router-dom": "static-1.9957",
  "content-media-capture": "static-1.5699",
  "knowledge-content-types": "static-1.8713",
  "ui-addon-emoji-picker": "static-1.10294",
  "ui-business-units-lib": "static-1.9523",
  "ui-shepherd-react": "static-3.10702",
  "hub-http-contrib": "static-1.3456",
  "ui-addon-sales-email": "static-1.5630",
  "commerce-tours-lib": "static-1.6795",
  "getting-started-shared-tasks": "static-1.19483",
  "sales-checkout-service-client": "static-1.3957",
  "merchandise-lib": "static-1.283",
  "getting-started-shared-tasks-store": "static-1.18601",
  "onboarding-tours-utils": "static-1.1389",
  "calling-error-reporting": "static-1.31759",
  "shared-worker-versioning": "static-1.11469",
  "calling-usage-tracker": "static-1.6962",
  "voice-sms-access-library": "static-1.2342",
  "conversations-skeleton-state": "static-1.7602",
  "commerce-permissions": "static-1.1208",
  "products-iframe-lib": "static-1.8821",
  "products-ui-components-shared-msw-handlers": "static-1.11207",
  "crm-index-associations-lib": "static-1.6876",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10908",
  "sales-views-client-types": "static-1.4686",
  "location-customization-utils-lib": "static-1.10337",
  "bark-lib": "static-1.16959",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6316",
  "react-codemirror": "static-1.11068",
  "data-agent-kit": "static-1.829",
  "data-token-picker": "static-1.17058",
  "markdown-it": "static-1.6",
  "fsm": "static-1.4183",
  "policy-lib": "static-1.7234",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10971",
  "embedded-academy-lib": "static-1.15885",
  "hubs-service-types": "static-1.1693",
  "navigation-components": "static-1.19082",
  "nudge-client-utils": "static-1.3339",
  "purchase-motions-api": "static-1.6578",
  "signup-constants": "static-1.19857",
  "idb-keyval": "static-1.54",
  "magpie-types": "static-1.5324",
  "reactive-lib": "static-1.1151",
  "simple-logging-lib": "static-1.3480",
  "nav-meta": "static-1.30719",
  "cms-field-types": "static-1.5240",
  "content-icons-ui": "static-1.2418",
  "integrations-lib": "static-1.17322",
  "underscore": "static-1.8",
  "unified-auth-core-lib": "static-1.1437",
  "social-insights-client-types": "static-1.22860",
  "outpost": "static-1.4561",
  "reporting-client-types": "static-1.2792",
  "signup-ui-url-generator": "static-2.8487",
  "developer-experience-shared-components": "static-1.10966",
  "immutable-less": "static-1.5079",
  "marketplace-ui-client-types": "static-1.18381",
  "marketplace-ui-common": "static-1.20974",
  "ui-addon-integrations-directory-panel": "static-2.8389",
  "ui-extensibility-client-types": "static-1.4344",
  "growth-data-modal": "static-1.6065",
  "growth-onboarding-next-action-utils": "static-1.2907",
  "onboarding-tours-client": "static-1.5537",
  "ui-shepherd-tracker": "static-1.8083",
  "ui-coaching-tips": "static-1.29526",
  "breeze-engine-chat-components": "static-1.1007",
  "breeze-engine-core": "static-1.1307",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "content-media-composition-data-lib": "static-1.13503",
  "content-media-compositions": "static-2.17510",
  "media-bridge-lib": "static-1.19573",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4854",
  "calling-orchestration-schema": "static-1.37119",
  "crm-record-cards-service-types": "static-1.3840",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16588",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15345",
  "nest": "static-1.664",
  "nudge-custom-function-registry": "static-1.3096",
  "nudge-renderer-utils": "static-1.3415",
  "whisper-core-api": "static-1.7561",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14737",
  "integrations-tracking-lib": "static-1.6040",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1155",
  "apps-service-types": "static-1.4075",
  "oauth-service-types": "static-1.4597",
  "ai-settings-ui-library": "static-1.8509",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1457",
  "onboarding-data-sync-lib": "static-1.2769",
  "growth-onboarding-next-action-components": "static-1.2935",
  "user-context-client": "static-1.4937",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4121",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4821",
  "trellis-ecosystem": "static-1.7785",
  "wootric-nps": "static-1.7272",
  "universal-page-editor-lib": "static-1.3437",
  "adobe-sign-auth-lib": "static-1.684",
  "ads-unified-auth-lib": "static-1.1799",
  "custom-vendor-connection-lib": "static-1.205",
  "google-sheets-integration-lib": "static-1.1252",
  "microsoft-drive-auth-lib": "static-1.412",
  "surveymonkey-integration-lib": "static-1.780",
  "slack-ui-library": "static-1.10825",
  "settings-ui-lib": "static-1.12958",
  "simple-data-table": "static-1.3751",
  "meetings-connect-utils-lib": "static-1.8044"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28616",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.1971",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.507",
  "crm_data": "/crm_data/static-4.93103",
  "data-fetching-client": "/data-fetching-client/static-1.10074",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8676",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1701",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6017",
  "hs-test-utils": "/hs-test-utils/static-1.8466",
  "hub-http": "/hub-http/static-1.6637",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11920",
  "I18n": "/I18n/static-7.1698",
  "jasmine-runner": "/jasmine-runner/static-1.6879",
  "quartz": "/quartz/static-1.7601",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.119",
  "react-utils": "/react-utils/static-2.5633",
  "reselect": "/reselect/static-3.15",
  "stripe-js": "/stripe-js/static-1.118",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6057",
  "UIComponents": "/UIComponents/static-3.8866",
  "usage-tracker-public": "/usage-tracker-public/static-1.7553",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38013",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.539",
  "cssUtils": "/cssUtils/static-1.1050",
  "customer-data-objects": "/customer-data-objects/static-1.8121",
  "FireAlarmUi": "/FireAlarmUi/static-1.4814",
  "foundations-assets": "/foundations-assets/static-1.5313",
  "foundations-theming": "/foundations-theming/static-1.4911",
  "graphql": "/graphql/static-1.92",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12227",
  "icons": "/icons/static-2.699",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3314",
  "property-translator": "/property-translator/static-1.5807",
  "quartz-config": "/quartz-config/static-1.1379",
  "quartz-core": "/quartz-core/static-1.6820",
  "quartz-i18n": "/quartz-i18n/static-1.1276",
  "quartz-routing": "/quartz-routing/static-1.1031",
  "quartz-tracking": "/quartz-tracking/static-1.980",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17162",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.83",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10799",
  "rpc-client-utils": "/rpc-client-utils/static-1.5098",
  "sanitize-text": "/sanitize-text/static-1.8584",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "superstore": "/superstore/static-1.5186",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11574",
  "ui-images": "/ui-images/static-2.1269",
  "usage-tracker-core": "/usage-tracker-core/static-1.7592",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3878",
  "quartz-webpack": "/quartz-webpack/static-1.3825",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.679",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "crm_universal": "/crm_universal/static-1.22656",
  "customer-data-email": "/customer-data-email/static-1.18589",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10261",
  "dispatcher": "/dispatcher/static-1.146",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8346",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8191",
  "quick-fetch": "/quick-fetch/static-1.4201",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4945",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2627",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9852",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.95",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2974",
  "ui-fonts": "/ui-fonts/static-1.1182",
  "HeadJS": "/HeadJS/static-2.816",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3577",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.24",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.371",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4736",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6159",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5175",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20454",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19489",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11246",
  "crm-message-bus": "/crm-message-bus/static-1.44008",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13458",
  "customer-data-properties": "/customer-data-properties/static-1.52920",
  "growth-payments-core": "/growth-payments-core/static-1.26419",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9504",
  "usage-tracker": "/usage-tracker/static-1.7742",
  "usage-tracker-container": "/usage-tracker-container/static-1.7732",
  "sassPrefix": "/sassPrefix/static-1.317",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4118",
  "foundations-theming-base": "/foundations-theming-base/static-1.3896",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3394",
  "stylex": "/stylex/static-1.45",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.215",
  "hub-http-janus": "/hub-http-janus/static-1.901",
  "hubspotter-http": "/hubspotter-http/static-1.4941",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.599",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.590",
  "quartz-auth": "/quartz-auth/static-1.1276",
  "quartz-head": "/quartz-head/static-1.1266",
  "quartz-test": "/quartz-test/static-1.1276",
  "trellis-components": "/trellis-components/static-1.2993",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5428",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "immer": "/immer/static-1.104",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.508",
  "chirp-fetch": "/chirp-fetch/static-1.2329",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4901",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5142",
  "sequences-lib": "/sequences-lib/static-1.8701",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5022",
  "FileManagerCore": "/FileManagerCore/static-1.40259",
  "FileManagerLib": "/FileManagerLib/static-1.40400",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5306",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.685",
  "timezone-utils": "/timezone-utils/static-2.5659",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10651",
  "react-dnd-compat": "/react-dnd-compat/static-1.5038",
  "stylex-utils": "/stylex-utils/static-1.165",
  "trellis-theming": "/trellis-theming/static-1.1414",
  "react-flip-move": "/react-flip-move/static-1.82",
  "avatar-components": "/avatar-components/static-1.2912",
  "hs-resources": "/hs-resources/static-1.625",
  "pulse": "/pulse/static-1.1069",
  "utility-belt": "/utility-belt/static-1.2963",
  "zustand": "/zustand/static-1.88",
  "batch-promise": "/batch-promise/static-1.1974",
  "customer-data-associations": "/customer-data-associations/static-1.7760",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8473",
  "customer-data-tracking": "/customer-data-tracking/static-1.7300",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7320",
  "framework-data-table": "/framework-data-table/static-2.12767",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49950",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24118",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8173",
  "ui-addon-opt": "/ui-addon-opt/static-4.8812",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9943",
  "customer-data-rte": "/customer-data-rte/static-1.33825",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24760",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3491",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6462",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19205",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15768",
  "payment-link-components": "/payment-link-components/static-1.24365",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5531",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.79",
  "quotes-client-types": "/quotes-client-types/static-1.39101",
  "react-colorpicker": "/react-colorpicker/static-2.10640",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18519",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "user-context": "/user-context/static-1.5480",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1940",
  "atom": "/atom/static-1.5505",
  "reference-resolvers": "/reference-resolvers/static-1.8606",
  "calling-global-api": "/calling-global-api/static-1.66050",
  "calling-internal-common": "/calling-internal-common/static-1.31752",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67432",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59725",
  "commerce-products-lib": "/commerce-products-lib/static-1.10786",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4091",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4694",
  "crm-links": "/crm-links/static-1.6733",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4422",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10152",
  "external-options-client-types": "/external-options-client-types/static-1.4420",
  "formula-editor": "/formula-editor/static-1.14948",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3749",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4501",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1065",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3987",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4259",
  "property-value-citations": "/property-value-citations/static-1.3534",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8534",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.382",
  "smart-property-lib": "/smart-property-lib/static-1.8546",
  "tiered-pricing": "/tiered-pricing/static-1.2160",
  "topics-actions-lib": "/topics-actions-lib/static-1.603",
  "trial-components-library": "/trial-components-library/static-1.14305",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11341",
  "laboratory-lib": "/laboratory-lib/static-3.7578",
  "onboarding-scopes": "/onboarding-scopes/static-1.6880",
  "seat-types-lib": "/seat-types-lib/static-1.964",
  "magpie-lib": "/magpie-lib/static-1.5864",
  "navigation-messaging": "/navigation-messaging/static-1.8409",
  "ts-schema": "/ts-schema/static-1.4371",
  "opentelemetry-web": "/opentelemetry-web/static-1.20",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.128",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10825",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10823",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8558",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.723",
  "copilot-toolkit": "/copilot-toolkit/static-1.12067",
  "audio-components": "/audio-components/static-1.6505",
  "ContentUtils": "/ContentUtils/static-1.69371",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29992",
  "FileManagerImages": "/FileManagerImages/static-1.37911",
  "html-to-image": "/html-to-image/static-1.64",
  "immerable": "/immerable/static-1.4569",
  "ui-universal-auth": "/ui-universal-auth/static-1.9641",
  "urlinator": "/urlinator/static-1.4944",
  "video-components": "/video-components/static-1.14355",
  "video-data-lib": "/video-data-lib/static-1.36011",
  "video-embed": "/video-embed/static-1.36845",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.765",
  "event-emitter": "/event-emitter/static-1.1388",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4301",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.439",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.572",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7225",
  "persist-promise": "/persist-promise/static-1.4131",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13595",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.352",
  "reporting-data": "/reporting-data/static-1.69216",
  "purchase-motions-components": "/purchase-motions-components/static-1.6575",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7010",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5510",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19506",
  "onboarding-tours": "/onboarding-tours/static-1.17322",
  "stripe-connect-js": "/stripe-connect-js/static-1.81",
  "chatspot-core": "/chatspot-core/static-1.23571",
  "content-assistance-lib": "/content-assistance-lib/static-1.8356",
  "draft-content-plugins": "/draft-content-plugins/static-1.29084",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22288",
  "rich-text-lib": "/rich-text-lib/static-1.20486",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2029",
  "poll-commands": "/poll-commands/static-1.3902",
  "video-components-external": "/video-components-external/static-1.12353",
  "trellis-story-utils": "/trellis-story-utils/static-1.4930",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9957",
  "content-media-capture": "/content-media-capture/static-1.5699",
  "knowledge-content-types": "/knowledge-content-types/static-1.8713",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10294",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9523",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10702",
  "hub-http-contrib": "/hub-http-contrib/static-1.3456",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5630",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6795",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19483",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3957",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18601",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1389",
  "calling-error-reporting": "/calling-error-reporting/static-1.31759",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11469",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6962",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2342",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "commerce-permissions": "/commerce-permissions/static-1.1208",
  "products-iframe-lib": "/products-iframe-lib/static-1.8821",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11207",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6876",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10908",
  "sales-views-client-types": "/sales-views-client-types/static-1.4686",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10337",
  "bark-lib": "/bark-lib/static-1.16959",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6316",
  "react-codemirror": "/react-codemirror/static-1.11068",
  "data-agent-kit": "/data-agent-kit/static-1.829",
  "data-token-picker": "/data-token-picker/static-1.17058",
  "markdown-it": "/markdown-it/static-1.6",
  "fsm": "/fsm/static-1.4183",
  "policy-lib": "/policy-lib/static-1.7234",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10971",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15885",
  "hubs-service-types": "/hubs-service-types/static-1.1693",
  "navigation-components": "/navigation-components/static-1.19082",
  "nudge-client-utils": "/nudge-client-utils/static-1.3339",
  "purchase-motions-api": "/purchase-motions-api/static-1.6578",
  "signup-constants": "/signup-constants/static-1.19857",
  "idb-keyval": "/idb-keyval/static-1.54",
  "magpie-types": "/magpie-types/static-1.5324",
  "reactive-lib": "/reactive-lib/static-1.1151",
  "simple-logging-lib": "/simple-logging-lib/static-1.3480",
  "nav-meta": "/nav-meta/static-1.30719",
  "cms-field-types": "/cms-field-types/static-1.5240",
  "content-icons-ui": "/content-icons-ui/static-1.2418",
  "integrations-lib": "/integrations-lib/static-1.17322",
  "underscore": "/underscore/static-1.8",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1437",
  "social-insights-client-types": "/social-insights-client-types/static-1.22860",
  "outpost": "/outpost/static-1.4561",
  "reporting-client-types": "/reporting-client-types/static-1.2792",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8487",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10966",
  "immutable-less": "/immutable-less/static-1.5079",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18381",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20974",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8389",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4344",
  "growth-data-modal": "/growth-data-modal/static-1.6065",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2907",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5537",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8083",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29526",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1007",
  "breeze-engine-core": "/breeze-engine-core/static-1.1307",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13503",
  "content-media-compositions": "/content-media-compositions/static-2.17510",
  "media-bridge-lib": "/media-bridge-lib/static-1.19573",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4854",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37119",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3840",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16588",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15345",
  "nest": "/nest/static-1.664",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3096",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3415",
  "whisper-core-api": "/whisper-core-api/static-1.7561",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14737",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6040",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1155",
  "apps-service-types": "/apps-service-types/static-1.4075",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8509",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1457",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2769",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2935",
  "user-context-client": "/user-context-client/static-1.4937",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4121",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4821",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7785",
  "wootric-nps": "/wootric-nps/static-1.7272",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3437",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.684",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1799",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.205",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1252",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.412",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.780",
  "slack-ui-library": "/slack-ui-library/static-1.10825",
  "settings-ui-lib": "/settings-ui-lib/static-1.12958",
  "simple-data-table": "/simple-data-table/static-1.3751",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8044"
}
};
